import React, { createContext, useState, useContext, PropsWithChildren } from 'react';

interface MenuContextType {
  isMenuCollapsed: boolean;
  toggleMenu: () => void;
}

const MenuContext = createContext<MenuContextType>({
  isMenuCollapsed: false,
  toggleMenu: () => {}
});

export const MenuProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(window.innerWidth < 992);

  const toggleMenu = () => {
    setIsMenuCollapsed(prev => !prev);
  };

  React.useEffect(() => {
    const handleResize = () => {
      setIsMenuCollapsed(window.innerWidth < 992);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <MenuContext.Provider value={{ isMenuCollapsed, toggleMenu }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);
